import React from "react";

const TRAILER_URL = "https://www.youtube.com/watch?v=fa-tgUd4YKo";
const TRAILER_THUMBNAIL =
	"../assets/img/new_design/GraphicAssets/gameplay-trailer-thumbnail.jpg";

export const GameplayTrailerBlock = () => {
	return (
		<div className="dreamworld-video-block">
			<div className="text-wrapper">GAMEPLAY TRAILER</div>
			<div className="video-wrapper">
				<a
					className="video-link"
					href={TRAILER_URL}
					target="_blank"
					rel="noopener noreferrer"
					aria-label="Watch gameplay trailer on YouTube"
				>
					<img
						className="video"
						src={TRAILER_THUMBNAIL}
						alt="DreamWorld gameplay trailer"
					/>
					<span className="video-play-icon" aria-hidden="true" />
				</a>
			</div>
		</div>
	);
};
